module.exports = __webpack_public_path__ + "media/partenaire/hero-1c8bcca0.png";